// extracted by mini-css-extract-plugin
export var btnContainer = "style-mod--btn-container--bc865";
export var cartBtn = "style-mod--cart-btn--b8dab";
export var clipStar = "style-mod--clip-star--7f275";
export var fullWidthBox = "style-mod--full-width-box--2dc50";
export var headerLinkWrapper = "style-mod--header-link-wrapper--84b83";
export var ratingText = "style-mod--rating-text--84467";
export var richText = "style-mod--rich-text--e4b1e";
export var richTextImg = "style-mod--rich-text-img--e521e";
export var richtextBtn = "style-mod--richtext-btn--d05d5";
export var sideHeader = "style-mod--side-header--73181";
export var styledBox = "style-mod--styled-box--47eea";
export var subHeader = "style-mod--sub-header--b43a7";
export var table = "style-mod--table--54564";
export var videoRenderWrapper = "style-mod--video-render-wrapper--f92b0";
export var yStars = "style-mod--y-stars--51027";